/**
 * Screen shake controller. Call shake() to trigger, apply() each frame to offset a container.
 */
export class ScreenShake {
  constructor() {
    this.intensity = 0;
    this.duration = 0;
    this.timer = 0;
    this.offsetX = 0;
    this.offsetY = 0;
  }

  /**
   * Trigger a screen shake.
   * @param {number} intensity - Max pixel offset (e.g. 2 for light, 5 for heavy)
   * @param {number} duration - Duration in seconds
   */
  shake(intensity, duration) {
    // Only override if stronger than current shake
    if (intensity > this.intensity || this.timer <= 0) {
      this.intensity = intensity;
      this.duration = duration;
      this.timer = duration;
    }
  }

  /**
   * Update the shake state and calculate offsets.
   * @param {number} dt - Delta time in seconds
   */
  update(dt) {
    if (this.timer <= 0) {
      this.offsetX = 0;
      this.offsetY = 0;
      return;
    }

    this.timer -= dt;
    const progress = Math.max(0, this.timer / this.duration);
    const currentIntensity = this.intensity * progress;

    this.offsetX = Math.round((Math.random() * 2 - 1) * currentIntensity);
    this.offsetY = Math.round((Math.random() * 2 - 1) * currentIntensity);

    if (this.timer <= 0) {
      this.timer = 0;
      this.intensity = 0;
      this.offsetX = 0;
      this.offsetY = 0;
    }
  }
}
